<template>
  <v-list-item
    v-if="availableLanguages.length && activeLanguage?.iso && needTranslate"
    :data-qa="`change-language-button-${activeLanguage.iso}`"
    @click="emit('click')"
  >
    <v-list-item-icon>
      <v-img
        width="24"
        height="16"
        contain
        :alt="activeLanguage.iso"
        :src="activeLanguage.flag_image?.url"
      />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title class="text-body-1 text--text">
        {{ activeLanguage.translations?.[`name_${activeLanguage.iso}`] || activeLanguage.name }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script setup lang="ts">
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore } from 'src/store'

const emit = defineEmits(['click'])

const { context }: ContextStore = useContextStore()

const needTranslate = Boolean(context.need_translate)
const activeLanguage = context.current_language
const availableLanguages = context.available_languages || []
</script>
